import { I18N_NAMESPACE } from "../../../common/constants/i18n"

import { getHorizontalSigningConditionsValues, HORIZONTAL_SIGNING_CONDITION_UNKNOWN } from "./horizontalSigningConditions"

export const deliverFormConfig = {
    namespace: I18N_NAMESPACE,
    deliverActions: {
        fieldName: "forms.campaignDeliverForm.horizontalSigning.deliverAction.label",
        options: [
            {
                value: "KEEP",
                labelKey: "forms.campaignDeliverForm.horizontalSigning.deliverAction.keep",
            },
            {
                value: "HORIZONTAL_SIGN_TO_GOOD",
                labelKey: "forms.campaignDeliverForm.horizontalSigning.deliverAction.toGood",
            },
            {
                value: "HORIZONTAL_SIGN_TO_AVERAGE",
                labelKey: "forms.campaignDeliverForm.horizontalSigning.deliverAction.toAverage",
            },
            {
                value: "HORIZONTAL_SIGN_TO_BAD",
                labelKey: "forms.campaignDeliverForm.horizontalSigning.deliverAction.toBad",
            },
        ],
    },
    tags: {
        tagsToAdd: "forms.campaignDeliverForm.horizontalSigning.tagsToAdd.label",
        tagsToDelete: "forms.campaignDeliverForm.horizontalSigning.tagsToDelete.label",
    },
}

export const pdfExportParams = (t, theme) => ({
    url: "horizontal_signing/horizontal_signs/export-pdf/",
    params: {
        "condition_colors": Object.fromEntries(
            Object.entries(getHorizontalSigningConditionsValues(t, theme))
                .filter(([condition]) => condition !== `${HORIZONTAL_SIGNING_CONDITION_UNKNOWN}`)
                .map(([condition, { color, backgroundColor }]) => [condition, { color, backgroundColor }])
        )
    }
})


export const campaignTextKeys = {
    namespace: I18N_NAMESPACE,
    deliverModalDesc: "containers.campaignDeliverModal.horizontalSigning.desc",
    deleteCampaignDesc: "components.campaignMenu.delete.confirm.horizontalSigning.desc",
}
